import { TextInput } from '@Pages/pageRuntime/components/ui/form/TextInput';
import { useDebouncedInput } from '@Pages/pageRuntime/hooks/useDebouncedInput';
import SearchIcon from 'lucide-react/dist/esm/icons/search';
import { useEffect, useRef } from 'react';

export interface SearchBarProps {
  onSearch: (value: string) => void;
  placeholder?: string;
  className?: string;
  defaultValue?: string;
  isLoading?: boolean;
}

export function SearchBar({
  onSearch,
  placeholder = 'Search...',
  className,
  defaultValue = '',
  isLoading = false
}: SearchBarProps) {
  const [inputValue, setInputValue, debouncedValue] = useDebouncedInput(350, defaultValue);
  const previousDebouncedValue = useRef(debouncedValue);

  useEffect(() => {
    if (previousDebouncedValue.current === debouncedValue) {
      return;
    }

    previousDebouncedValue.current = debouncedValue;
    onSearch(debouncedValue);
  }, [debouncedValue, onSearch]);

  return (
    <TextInput
      className={className}
      placeholder={placeholder}
      aria-label={placeholder}
      value={inputValue}
      onChange={setInputValue}
      isLoading={isLoading}
      prefixIcon={SearchIcon}
    />
  );
}
